<template>
  <div>
    <div v-if="cookieConsent === CookieConsent.UNDEFINED" class="cookie-banner">
      <button class="close-btn" @click="declineCookies">&times;</button>
      <div class="cookie-block-description">
        На нашем сайте используются cookie–файлы, в том числе сервисов веб–аналитики. Продолжая использовать наш сайт, вы соглашаетесь с
        <router-link :to="{ name: 'cookiePolicy' }" target="_blank" >
          политикой использования Cookies
        </router-link>
        Это файлы в браузере, которые помогают нам сделать ваш опыт взаимодействия с сайтом удобнее.
      </div>
      <button @click="acceptCookies" class="ok-btn">Хорошо</button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';

enum CookieConsent {
  UNDEFINED = "undefined",
  ACCEPTED = "accepted",
  DECLINED = "declined"
}

export default defineComponent({
  name: "CookieConsent",
  setup() {
    const cookieConsent = ref<CookieConsent>(
        (localStorage.getItem('cookieConsent') as CookieConsent) || CookieConsent.UNDEFINED
    );

    const loadYandexMetrika = () => {
      if (cookieConsent.value !== CookieConsent.ACCEPTED) return;

      (function (m: any, e: any, t: any, r: any, i: any, k?: any, a?: any) {
        (m[i] = m[i] || function (...args: any[]) {
          (m[i].a = m[i].a || []).push(args);
        }) as any;
        m[i].l = Date.now();
        k = e.createElement(t);
        a = e.getElementsByTagName(t)[0];
        k.async = 1;
        k.src = r;
        a.parentNode?.insertBefore(k, a);
      })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      if (typeof window.ym === "function") {
        window.ym(86800019, "init", {
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true
        });
      }
    };

    const removeYandexMetrika = () => {
      const script = document.querySelector('script[src*="mc.yandex.ru"]');
      if (script) script.remove();

      const img = document.querySelector('img[src*="mc.yandex.ru/watch"]');
      if (img) img.remove();

      if (window.ym) {
        window.ym(86800019, "stop", {});
      }
    };

    const clearCookies = () => {
      const cookies = document.cookie.split(";");

      cookies.forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();

        // Не удаляем важные cookies (например, session_id)
        if (cookieName !== "session_id") {
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        }
      });

      // Также очищаем localStorage и sessionStorage от трекеров
      localStorage.removeItem("cookieConsent");
      sessionStorage.clear();
    };

    onMounted(() => {
      if (cookieConsent.value === CookieConsent.ACCEPTED) {
        loadYandexMetrika();
      }
    });

    watch(cookieConsent, (newValue) => {
      if (newValue === CookieConsent.ACCEPTED) {
        loadYandexMetrika();
      } else if (newValue === CookieConsent.DECLINED) {
        clearCookies();
        removeYandexMetrika();
      }
    });

    const acceptCookies = () => {
      localStorage.setItem('cookieConsent', CookieConsent.ACCEPTED);
      cookieConsent.value = CookieConsent.ACCEPTED;
      loadYandexMetrika();
    };

    const declineCookies = () => {
      localStorage.setItem('cookieConsent', CookieConsent.DECLINED);
      cookieConsent.value = CookieConsent.DECLINED;
      clearCookies();
      removeYandexMetrika();
    };

    return {
      cookieConsent,
      CookieConsent,
      acceptCookies,
      declineCookies
    };
  }
});
</script>

<style>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 1);
  color: white;
  padding: 15px;
  text-align: center;
  z-index: 9999;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.5);
}

.cookie-block-description {
  max-width: 80%;
  margin: 10px auto;
  text-align: center;
  padding-top: 20px;
  font-size: 1.3rem;
}

.ok-btn {
  color: #000;
  background: #18d26e;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 10px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 2rem;
  color: white;
  cursor: pointer;
}

@media (max-width: 600px) {
  .cookie-banner {
    padding: 20px;
  }

  .cookie-block-description {
    max-width: 90%;
    font-size: 1.3rem;
  }
}
</style>
